<template>
  <Card  class="my-4 relative overflow-hidden" :class="{ 'border border-yellow-300' : selected}">
    <div class="flex">
      <div class="flex-1 text-sm text-white">
        <div class="items-center mt-3">
          <span class="mr-1 ">{{ shopName }}</span>
        </div>
      </div>
      <div class="flex-1">
        <img class="float-left" v-bind:src="this.imgurlInternal"/>
      </div>
        
      </div>
      <div class="flex gap-2 justify-center items-center">
          <button class="bg-blue-500 rounded-3xl w-32 text-sm"  @click.prevent="$refs.file.click()">انتخاب فایل
          </button>
          <input type="file" ref="file" @change="onFileChanged" style="display:none">
          </div>
    <hr class="mt-1">
    </Card>


</template>
<script>
import Card from "@/components/General/VCard"
import {UploadImage} from "@/API/API.js";
export default {
  props: ['id','catid','code', 'name','sortorder','submenutag','price','description','baseurl','servicetag','imagepath','imgurl','selected'],
  name: 'MenuItemCard',
  emits: ['deleted'],
  components: {Card/*,Button*/},
  data() {
      return {
        image:null,
        imgurlInternal:this.baseurl+'\\'+this.imgurl,
        
      }
    },
  methods: {
    onFileChanged (event) {
       const file = event.target.files[0];
       this.image=file;
       //console.log(4444);
       this.onUpload()
       },
       onUpload() {
          const params = new FormData();
          params.append('Logo',this.image);
          this.$Progress.start()
          UploadImage('menuitem',String(this.id),params)
            .then(response=>  {
             this.imgurlInternal=this.baseurl+'\\'+response.data
             //this.imgurlInternal=this.baseurl+'\\'+response.data.result
             this.updateSuccessful = true
             //console.log(this.baseurl+'\\'+response.data.result);
             this.$Progress.finish()
             })
          .catch(error => {
          this.errorMessage = error.message;
          console.log("There was an error!", error);
          //this.$swal.fire( error.response.data.result);
          this.$swal.fire( error.response.data);
       });
       },
    //deleteMenuItem() {
    //  this.$emit('deleted', this.id)
   // }
  }
}
</script>
